export const getAlexState = state => state.alexState;

export const getIsAnimationDisabled = (state) => state.isAnimationDisabled;
